import { action, computed } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { LanguageInfo } from "../Shared";
import { AppStore } from "../Stores/AppStore";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import { Strings } from "../Stores/StringsStore";

interface IFileLanguageSelection {
	documentStore?: DocumentStoreImpl;
}

@inject('documentStore')
@observer
export class FileLanguageSelection extends React.Component<IFileLanguageSelection, {}> {

	render() {
		return <div className="wizardbox-content no--toolbar">
			<div className="wizardbox-module">
				<FileLanguageSelectionList />
			</div>
		</div>;
	}
}

@inject('documentStore')
@observer
class FileLanguageSelectionList extends React.Component<IFileLanguageSelection, {}> {

	@action handleClickItem = () => {
		this.props.documentStore.selectedFileLanguage = null;
		this.props.documentStore.fileLanguageWizardStore.confirmEnabled = true;
	}

	@computed get itemClass() {
		let isSelected = this.props.documentStore.selectedFileLanguage === null;
		return isSelected ? "is--selection-selected" : "";
	}

	render() {
		return <div className="list-simple">
			<ul>
				<li className={this.itemClass} onClick={this.handleClickItem}>
					<a>
						<span>
							{Strings.general.invariantLanguageCaption}
						</span>
					</a>
				</li>
				{
					AppStore.context.contentLanguages.map(item => {
						return <FileLanguageSelectionListItem key={item.name} item={item} />
					})
				}
			</ul>
		</div>;
	}
}

interface IFileLanguageSelectionListItemProps extends IFileLanguageSelection {
	item: LanguageInfo;
}

@inject('documentStore')
@observer
class FileLanguageSelectionListItem extends React.Component<IFileLanguageSelectionListItemProps, {}> {


	@action handleClickItem = () => {
		this.props.documentStore.selectedFileLanguage = this.props.item.name;
		this.props.documentStore.fileLanguageWizardStore.confirmEnabled = true;
	}

	@computed get itemClass() {
		let isSelected = this.props.documentStore.selectedFileLanguage === this.props.item.name;
		return isSelected ? "is--selection-selected" : "";
	}


	render() {
		return <li className={this.itemClass} onClick={this.handleClickItem}>
			<a>
				<span>
					{this.props.item.caption}
				</span>
			</a>
		</li>
	}
}
